import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { v4 as uuidv4 } from "uuid";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyA-qyOZ_LwxaId9plB_JTa9JPvmp2B0yb0",
  authDomain: "math-club-competition-site.firebaseapp.com",
  databaseURL: "https://math-club-competition-site.firebaseio.com",
  projectId: "math-club-competition-site",
  storageBucket: "math-club-competition-site.appspot.com",
  messagingSenderId: "1093925268297",
  appId: "1:1093925268297:web:5670ddf822e8486716c898",
  measurementId: "G-J1HL3HH23K",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const db = firebase.firestore();
const provider = new firebase.auth.GoogleAuthProvider();

export const getBot = () => {
  let xmlHttp = new XMLHttpRequest();
  xmlHttp.open("POST", "https://math-club-submissions-bot.herokuapp.com/", true);
  xmlHttp.setRequestHeader("Access-Control-Allow-Origin", "*");
  xmlHttp.send(null);
};

export const signInWithGoogle = () => {
  getBot();
  auth.signInWithRedirect(provider);
};

export const signOut = () => {
  auth
    .signOut()
    .then(function () {
      // Sign-out successful.
    })
    .catch(function (error) {
      // An error happened.
    });
};

export const addAdmin = (email) => {
  db.collection("globals").doc("data").set({
    admins: {[email] : null}
  }, { merge: true });
}

export const addUser = (user, username, grade, emailList) => {
  getBot();
  db.collection("users").doc(user.uid).set({
    username: username,
    fullName: user.displayName,
    grade: grade,
    emailList: emailList,
    createdTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
  });
  db.collection("submissions").doc(user.uid).set({});
  db.collection("filSubmissions").doc(user.uid).set({});
};

export const submitFile = (topic, problems, link) => {
  getBot();
  let updateMap = {};
  let uuid = uuidv4();
  updateMap[uuid] = {
    topic: topic,
    problems: problems,
    link: link,
    timestamp: firebase.firestore.FieldValue.serverTimestamp()
  };
  db.collection("fileSubmissions").doc(auth.currentUser.uid).update(updateMap);
  return uuid;
};

export const submitFlag = (user, topic, problem, flag) => {
  getBot();
  let updateMap = {};
  let uuid = uuidv4();
  updateMap[uuid] = {
    topic: topic,
    problem: problem,
    flag: flag,
  };
  db.collection("submissions").doc(user.uid).update(updateMap);
  return uuid;
};
